
export { GGUSection } from "/codebuild/output/src1227593752/src/packages/shared-components/src/campaign/GGUSection.tsx"